import { computed, getCurrentInstance } from 'vue'
import { useProjectBillingStatus } from '@/hooks/useProjectBillingStatus'

const BILLING_ROUTE_NAMES = new Set(['Billing', 'SpecialPayment', 'FinanceLinks'])

export function useAppMobileBillingLock() {
    const root = getCurrentInstance()!.proxy as any
    const { isBillingBlocked } = useProjectBillingStatus()

    const isMobile = computed(() => Boolean(root.$vuetify?.breakpoint?.smAndDown))
    const isProjectPath = computed(() => {
        const path = root.$route?.path || ''
        return path.split('/')[1] === 'project'
    })
    const isBillingRoute = computed(() => {
        const name = root.$route?.name
        const path = root.$route?.path || ''
        return BILLING_ROUTE_NAMES.has(name) || /\/billing(\/?$|\?|\/)/.test(path)
    })

    const showAppMobileBillingLock = computed(
        () =>
            isMobile.value &&
            isProjectPath.value &&
            Boolean(isBillingBlocked.value) &&
            !isBillingRoute.value
    )

    return {
        showAppMobileBillingLock,
        isBillingRoute,
    }
}
